import React from "react";
const Select = ({
  label,
  placeholder,
  text,
  options,
  error,
  value,
  onChange,
}) => {
  return (
    <div className="form-group">
      <label>{label}</label>
      <select value={value} onChange={onChange}>
        <option>{placeholder}</option>
        {options.map((item,index) => {
          return <option key={item.id+item.defaultName} value={item.id}>{item.defaultName}</option>;
        })}
      </select>
      {text && <span>{text}</span>}
      {error && <div className="error">{error}</div>}
    </div>
  );
};
export default Select;
